import type * as awsAmplifyAuth from 'aws-amplify/auth'
/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State {
  session?: awsAmplifyAuth.AuthSession
  error?: Error
}
export namespace State {
  export const INITIAL: State = {}
}
